/**
 * A global namespace for `ArrowRight` key.
 * e.which = 39 equivalent
 */
const keyArrowRight = 'ArrowRight';

export default keyArrowRight;
